import { StyledContainer } from "./styles";
import { ContainerProps } from "../types";

const Container = ({ border, offsetTop, children }: ContainerProps) => (
  <StyledContainer border={border} offsetTop = {offsetTop}>{children}</StyledContainer>
);

export default Container;
